var _defs, _path, _rect, _rect2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect3, _rect4, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBugFixedMonochromatic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 823.07 585.39",
    "data-imageid": "bug-fixed-monochromatic",
    imageName: "Bug Fixed",
    className: "illustrations_image",
    style: {
      width: 237
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 399.48,
    y1: 498.46,
    x2: 402.65,
    y2: 582.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 408.43,
    y1: 94.74,
    x2: 408.43,
    y2: 603.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fff",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#fff",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#fff",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#fff",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 398.46,
    y1: 293.63,
    x2: 412.71,
    y2: 513.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 512.32,
    y1: 347.86,
    x2: 733.25,
    y2: 347.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#183866"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a7fc1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 613.94,
    y1: 398.53,
    x2: 822.78,
    y2: 398.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecc4d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#efd4d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2eac9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 675.48,
    y1: 340.69,
    x2: 491.05,
    y2: 365.78,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 402.88,
    y1: 550.1,
    x2: 402.88,
    y2: 597.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 525.35,
    y1: 200.05,
    x2: 579.84,
    y2: 200.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 589.61,
    y1: 175.79,
    x2: 675.6,
    y2: 175.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 557.39,
    y1: 159,
    x2: 629.28,
    y2: 222.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 580.58,
    y1: 320.97,
    x2: 650.76,
    y2: 320.97,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 614.41,
    y1: 331.93,
    x2: 613.55,
    y2: 359.24,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 620.33,
    y1: 358.98,
    x2: 620.33,
    y2: 374.79,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 624.23,
    y1: 369.44,
    x2: 625.09,
    y2: 392.72,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 429.8,
    y1: 140.22,
    x2: 364.14,
    y2: 424.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 441.6,
    y1: 142.95,
    x2: 375.93,
    y2: 427.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 371.79,
    y1: 126.81,
    x2: 306.13,
    y2: 410.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 679.65,
    y1: 476.79,
    x2: 800.49,
    y2: 476.79,
    xlinkHref: "#linear-gradient-4"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "41. Bug Fixed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M679.65,567.93c-20.73,12.77-31.09,13.14-55.44,13.14q-82.82,0-165.64-.78L470,575.9c.67-6.34-8.09-8.66-14.47-8.56l-288.85,4.23c-51.52.75-110.38-1.68-143.38-41.25-18.37-22-24.77-52.4-21.54-80.89s5.85-90.71,89.78-165.19c27.77-24.65,59,8,66-28.49,10.5-54.62-31.09-109-21.56-163.83,5.11-29.38,25.08-55,50.53-70.59S242.35-.38,272.17,0c18,.24,36.24,2.85,52.5,10.54,15.88,7.52,29.13,19.51,43,30.33,20.3,15.87,42.69,29.68,67.5,36.61,49.67,13.87,102.12-1.07,153.36-6.88,44.4-5,90.88-2.77,131.34,16.19s73.83,56.93,78.45,101.37c5.05,48.51-22.78,101.38.82,144.06,6.63,12,19.6,20.54,23.48,33.67,6.78,22.91-13.76,58.21-2.2,103.24,6.81,26.55-19,61.78-45.13,76.26C763.68,551.82,729.29,537.35,679.65,567.93Z",
    transform: "translate(-0.93)",
    fill: "#68e1fd",
    opacity: 0.18,
    className: "target-color"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 312.16,
    y: 514.19,
    width: 178.46,
    height: 69.62,
    fill: "#68e1fd",
    className: "target-color"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 312.16,
    y: 514.19,
    width: 178.46,
    height: 69.62,
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M733.25,88.19v388a42.76,42.76,0,0,1-42.76,42.75H126.35A42.75,42.75,0,0,1,83.6,476.15v-388a42.76,42.76,0,0,1,42.75-42.76H690.49A42.77,42.77,0,0,1,733.25,88.19Z",
    transform: "translate(-0.93)",
    fill: "#68e1fd",
    className: "target-color"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M733.25,88.19v388a42.76,42.76,0,0,1-42.76,42.75H126.35A42.75,42.75,0,0,1,83.6,476.15v-388a42.76,42.76,0,0,1,42.75-42.76H690.49A42.77,42.77,0,0,1,733.25,88.19Z",
    transform: "translate(-0.93)",
    fill: "url(#linear-gradient-2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M733.25,417.54v58.61a42.74,42.74,0,0,1-42.76,42.75H126.35A42.75,42.75,0,0,1,83.6,476.15V417.54Z",
    transform: "translate(-0.93)",
    fill: "#68e1fd",
    className: "target-color"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M733.25,417.54v58.61a42.74,42.74,0,0,1-42.76,42.75H126.35A42.75,42.75,0,0,1,83.6,476.15V417.54Z",
    transform: "translate(-0.93)",
    fill: "url(#linear-gradient-3)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M733.25,472.87v3.28a42.71,42.71,0,0,1-19.94,36.16,111.38,111.38,0,0,1-13.68,4.89q-17.39-37.73-34.76-75.45c-3.79-8.2-7.69-16.58-12.52-24.21a72,72,0,0,0-14.73-17.29l-.9,17.29c-.27,5.13-.55,10.28-.81,15.41-.16,3-.38,6.17-2.12,8.61-3.27,4.56-10.61,4.26-15.06.84S612,433.49,610,428.26q-2.06-5.34-4-10.72-7.15-19.44-13.23-39.27C576,375.73,563.16,358,565.92,341.33c.64-3.85,2-7.55,2.68-11.36.94-5,.79-10.19.66-15.31L567,234.25a134,134,0,0,1-23.44-2.8,13.64,13.64,0,0,1-24.66,6.09c-2.37-3.35-3.1-7.57-3.66-11.65-.77-5.72-5.62-26.8-.95-31.1,4.18-3.85,19.34.77,25.58-.75,8.24-2,15.89-5.86,23.85-8.79A110.07,110.07,0,0,1,604,178.54c9.92.22,20.18,1.92,28.36,7.56s13.7,15.93,11.37,25.58c-4.73,1.59-8.36-4.8-13.23-5.83-2.43-.51-4.9.38-7.22,1.25q-13.78,5.21-27.57,10.41c-1.74.65-3.6,1.4-4.57,3s-.78,3.64-.48,5.5a82.91,82.91,0,0,0,14.43,35.17c6.67,9.32,15.26,17.24,21.18,27.06s8.8,22.68,3.08,32.61a5.36,5.36,0,0,0-.91,2.15c-.16,1.66,1.3,2.95,2.61,4C662.1,351,685,383.12,704.51,417.54,714.78,435.62,724.12,454.34,733.25,472.87Z",
    transform: "translate(-0.93)",
    opacity: 0.19,
    fill: "url(#linear-gradient-4)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M800.49,532.47l-.11.08a73.8,73.8,0,0,1-9,6l0,0a73.48,73.48,0,0,1-16,6.85S690,417.7,679.67,408.15l0,0c-7.95-7.31-22.21-11.67-29.59-14.54a16.9,16.9,0,0,1-4.36-2.14c-3.05-2.76-15.29-47.07-23.75-60.19-9.22-14.31-9.37-21.39-6-24.67a10.69,10.69,0,0,1,6.77-2.5c6.17-.43,13.32,1.85,13.32,1.85,1.65-3.22,1.19-6.62-.4-10.45-2.44-6-7.6-13-11.74-22-6.77-14.81,4.5-21.81,4.5-21.81s31.62,33.78,49.42,47.87,18.18,57.32,45.4,82.43,97.17,87.21,97.17,87.21C828.41,501.75,814.81,521.33,800.49,532.47Z",
    transform: "translate(-0.93)",
    fill: "url(#linear-gradient-5)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M660.28,375.94c2.5,4.48,3.56,21.55-10.22,17.65-4.32-1.22-8.93-.89-13.27-2a10.89,10.89,0,0,1-4-1.74c-2.58-2-3-5.64-3.59-8.86-2.41-13.85-10.3-26.24-13-40-1.21-6.08-1.48-12.61-4.78-17.85-2-3.18-5.18-6.63-3.73-10.09.67-1.59,2.18-2.64,3.62-3.6a36.63,36.63,0,0,1,4.7-2.8c.28-.13.57-.27.86-.38,1.41-.55,2.89-.9,4.3-1.45.55-.21,1.09-.43,1.61-.67,6.17-.43,13.32,1.85,13.32,1.85,1.65-3.22,1.19-6.62-.4-10.45,4.88,4,20.92,25.48,16.13,46.05C651,344.81,644.34,347.37,660.28,375.94Z",
    transform: "translate(-0.93)",
    opacity: 0.19,
    fill: "url(#linear-gradient-6)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 262.85,
    y: 573.97,
    width: 280.05,
    height: 11.43,
    fill: "#68e1fd",
    className: "target-color"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 262.85,
    y: 573.97,
    width: 280.05,
    height: 11.43,
    fill: "url(#linear-gradient-7)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M512.08,189.28l15.53-5.43,2.3,4.35s81.18-34.24,112.25-35,42.58,27.21,46.41,45.22c0,0-27-28-64.66-16.48s-86.34,28.24-86.34,28.24l1.53,7-14.94,5.75Z",
    transform: "translate(-0.93)",
    fill: "#68e1fd",
    className: "target-color"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M557.36,176.4l11.84,30.81a7.15,7.15,0,0,0,8.47,4.36l23-5.94a7.15,7.15,0,0,0,5.34-7.56l-3.08-34.86a7.17,7.17,0,0,0-9.28-6.2l-31.76,10A7.16,7.16,0,0,0,557.36,176.4Z",
    transform: "translate(-0.93)",
    fill: "#68e1fd",
    className: "target-color"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M566.57,200.37c-16.85,5.62-29,9.8-29,9.8l1.53,7-14.94,5.75-12.08-33.66,15.53-5.43,2.3,4.35s11.61-4.9,27.74-11Z",
    transform: "translate(-0.93)",
    fill: "url(#linear-gradient-8)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M688.57,198.41s-27-28-64.66-16.48c-6.07,1.85-12.42,3.84-18.81,5.87l-2.17-24.59a6.76,6.76,0,0,0-.35-1.63c15.41-4.67,29.92-8.15,39.58-8.39C673.23,152.43,684.74,180.4,688.57,198.41Z",
    transform: "translate(-0.93)",
    fill: "url(#linear-gradient-9)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M600.67,205.63l-23,5.94a7.15,7.15,0,0,1-8.47-4.36l-2.63-6.84-8.92-23.21-.29-.76a7.16,7.16,0,0,1,4.53-9.4l31.76-10a7.15,7.15,0,0,1,8.93,4.57,6.76,6.76,0,0,1,.35,1.63l2.17,24.59.91,10.27A7.15,7.15,0,0,1,600.67,205.63Z",
    transform: "translate(-0.93)",
    fill: "url(#linear-gradient-10)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M577.67,211.57l48.5,227.31s11,18.71,27.29,13.67S651.81,386.87,633.21,331s-32.38-112-32.54-125.33Z",
    transform: "translate(-0.93)",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M597.64,305.18s-20.26,5.59-16.63,15.71,38.28,18.55,56.63,15.1,13.9-11.41,7.88-15.1-46.39-8.71-46.39-8.71Z",
    transform: "translate(-0.93)",
    fill: "url(#linear-gradient-11)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M588.25,327.7s-13.32,10.34-8.43,19.8,54.39,13.05,63.55,10.35,5.29-12.1,2.65-14a109.29,109.29,0,0,1-8.38-7.82S612.09,339.72,588.25,327.7Z",
    transform: "translate(-0.93)",
    fill: "url(#linear-gradient-12)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M590.2,372.38s-9.62-13.66,5.15-17.63c0,0,38.48,6.18,48,3.1,0,0,11.17,4.39,10.09,12.34C652.07,380.42,596.07,382.07,590.2,372.38Z",
    transform: "translate(-0.93)",
    fill: "url(#linear-gradient-13)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M612,395.49s34,2.8,39.47-5.31S646,375.94,646,375.94s-32.26,4.29-42.07,1.88S591.7,390.61,612,395.49Z",
    transform: "translate(-0.93)",
    fill: "url(#linear-gradient-14)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M396,213.41c-.05-.12-.09-.26-.13-.39a53.12,53.12,0,0,0-4.6-11.1c-3.16-5.61-8-11.5-15-12.65a3.07,3.07,0,0,1,1-6.05c17.25,2.86,23.82,25.64,24.48,28.1a39.21,39.21,0,0,1,20.8-.11c.8-2.92,7.4-25.16,24.45-28a3.07,3.07,0,0,1,1,6.05c-6.95,1.15-11.84,7-15,12.65A52.84,52.84,0,0,0,428.4,213l-.06.24c10.39,4.55,19,13.44,24.38,24.82H372C377.27,226.83,385.76,218,396,213.41Z",
    transform: "translate(-0.93)",
    opacity: 0.47,
    fill: "url(#linear-gradient-15)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M458.53,267.83a65.48,65.48,0,0,1-1.71,12.28h13.83a4.6,4.6,0,0,1,3.26,7.86,4.66,4.66,0,0,1-3.26,1.34H456.29a4.43,4.43,0,0,1-2.21-.57,57.73,57.73,0,0,1-4.29,8.58h9.08a4.6,4.6,0,1,1,0,9.2H444.51a4.55,4.55,0,0,1-1.53-.26c-8.15,8.6-18.88,13.83-30.62,13.83s-22.53-5.25-30.69-13.89a4.5,4.5,0,0,1-1.69.32H365.61a4.59,4.59,0,0,1-4.6-4.6,4.59,4.59,0,0,1,4.6-4.6h9.3a59.66,59.66,0,0,1-4.33-8.69,4.47,4.47,0,0,1-2.39.68H353.82a4.6,4.6,0,1,1,0-9.2h14.07a63.93,63.93,0,0,1-1.7-12.21H352a4.61,4.61,0,1,1,0-9.21h14.46a63.9,63.9,0,0,1,1.84-10.3h88.19a64.16,64.16,0,0,1,1.85,10.41,4.71,4.71,0,0,1,1-.11h14.36a4.61,4.61,0,1,1,0,9.21H459.3A3.94,3.94,0,0,1,458.53,267.83Z",
    transform: "translate(-0.93)",
    opacity: 0.47,
    fill: "url(#linear-gradient-16)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M347.35,211.58a21,21,0,1,0,21,21A21,21,0,0,0,347.35,211.58Zm0,6.28a14.7,14.7,0,0,1,14.71,14.71,14.88,14.88,0,0,1-.49,3.8L337,222.16A14.64,14.64,0,0,1,347.35,217.86Zm0,29.42a14.72,14.72,0,0,1-14.17-18.67l24.69,14.25A14.73,14.73,0,0,1,347.35,247.28Z",
    transform: "translate(-0.93)",
    opacity: 0.47,
    fill: "url(#linear-gradient-17)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M800.49,532.47l-.11.08c-.71.5-4.5,3.2-9,6l0,0c-5.76,3.55-12.72,7.25-16,6.85,0,0-85.26-127.71-95.59-137.26l0,0s11.87.14,24.86,9.41S800.49,532.47,800.49,532.47Z",
    transform: "translate(-0.93)",
    opacity: 0.19,
    fill: "url(#linear-gradient-18)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBugFixedMonochromatic);
export default __webpack_public_path__ + "static/media/bug-fixed-monochromatic.2cff799ee0cbc38f934139d16b1f58b7.svg";
export { ForwardRef as ReactComponent };